<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline">
        <label>Reason:</label>
        <div>
          <quill-editor
            name="Reason"
            :options="editorOption"
            :content="editSubmittedReason"
            v-model="editSubmittedReason"
          />
        </div>
      </div>
      <div class="form-inline flex-row m-t-l">
        <spinnerButton class="submit primary" @click.native="buttonClick"
          >Submit</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["reason"],
  components: {
    spinnerButton,
  },
  data() {
    return {
      editSubmittedReason: "",
      editorOption: {
        modules: {
          toolbar: [
            ["link", "bold", "italic", { list: "ordered" }, { list: "bullet" }],
          ],
        },
        theme: "snow",
      },
    };
  },
  mounted() {
    this.editSubmittedReason = this.reason;
  },
  methods: {
    buttonClick: function () {
      this.$emit("updateSubmittedReason", this.editSubmittedReason);
    },
  },
};
</script>
